/** Protect a mobile browser meeting from accidental history navigation. */
export function installWebMeetingBack(handle: () => 'handled' | 'meeting' | 'none', onMeeting: () => void): () => void {
  let active = true;
  const marker = '__vorbelloMeetingBack';
  const arm = () => history.pushState({ ...(history.state || {}), [marker]: true }, '', location.href);
  const onPop = () => {
    if (!active) return;
    const result = handle();
    if (result === 'none') return;
    arm();
    if (result === 'meeting') onMeeting();
  };
  arm();
  window.addEventListener('popstate', onPop);
  return () => {
    active = false;
    window.removeEventListener('popstate', onPop);
    if (history.state?.[marker]) {
      const state = { ...history.state }; delete state[marker];
      history.replaceState(state, '', location.href);
    }
  };
}
